module.exports = __webpack_public_path__ + "static/media/s3.6bb1a37c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s3.jpg
// module id = 112
// module chunks = 0